import { useQuery } from "@tanstack/react-query";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ReactNode, useEffect, useState, useMemo } from "react";
// import CustomerOnBoardingComponent from "pages/modules/customer/customers/components/on-boarding-customer/CustomerOnBoardingComponent";
// import {CustomerOnBoardingDrawer} from "pages/modules/customer/customers";
import {
  useGetAllCustomers,
  useGetAllCustomerUsersByMspId,
  useGlobalStore,
  useMainStore,
  useNonPersistantMainStore,
} from "controller";
import {
  CustomerOnBoardingComponent,
  CustomerOnBoardingDrawer,
} from "pages/modules/customer/customers";
import React from "react";

interface CustomerOnBoardingWrapperProps {
  children: ReactNode;
}

export const CustomerOnBoardingWrapper = ({
  children,
}: CustomerOnBoardingWrapperProps) => {
  const theme = useTheme();
  const [isPermitted, setIsPermitted] = useState(true);
  const [userOnBoarding, setUserOnBoarding] = useState(true);
  const [isOnboardingDrawerOpen, setIsOnboardingDrawerOpen] = useState(false);
  const [isUserOnBoardingDrawerOpen, setIsUserOnBoardingDrawerOpen] =
    useState(false);
  const customerCount = useNonPersistantMainStore(
    (state) => state.customerCount,
  );
  const setCustomerCount = useNonPersistantMainStore(
    (state) => state.setCustomerCount,
  );
  const setUsers = useNonPersistantMainStore((state) => state.setUsers);
  const setUserCount = useNonPersistantMainStore((state) => state.setUserCount);
  const userCount = useNonPersistantMainStore((state) => state.userCount);
  const mspId = useGlobalStore((state) => state.mspId);
  const sampleDataStatus = useGlobalStore((state) => state.sampleDataStatus);

  //customer fetching
  const {
    data: customer,
    isLoading: isCustomerLoading,
    refetch: refetchCustomer,
  } = useGetAllCustomers({
    pageNumber: 1,
    perPageCount: 5,
    sortColumn: "customer_name",
    sortDirection: "asc",
    filter: [
      { column: "is_active", operator: "=", value: "true" },
      { column: "customer.meta", operator: "@<", value: { is_sample: true } },
    ],
    enabled: customerCount && customerCount > 0 ? false : true,
  });

  // user fetching
  const {
    data: usersData,
    isLoading: isUsersLoading,
    refetch: refetchUsers,
  } = useGetAllCustomerUsersByMspId({
    mspId,
    sortColumn: "users.created_at",
    sortDirection: "desc",
    searchQuery: "",
    pageNumber: 1,
    perPageCount: 5,
    filter: [
      {
        column: "users.meta",
        operator: "@<",
        value: { is_resource: true },
      },
      {
        column: "users.meta",
        operator: "@<",
        value: { is_sample: true },
      },
    ],
    enabled: userCount && userCount > 0 ? false : true,
  });

  // Combine the two useEffects into one to reduce render cycles
  useEffect(() => {
    const updatePermissions = (count: number) => {
      const newPermissionStatus = count > 0 && !isOnboardingDrawerOpen;
      setCustomerCount(count);
      if (newPermissionStatus !== isPermitted) {
        setIsPermitted(newPermissionStatus);
      }
    };

    if (!isOnboardingDrawerOpen && customerCount && customerCount > 0) {
      refetchCustomer().then((result) => {
        if (result.data) {
          updatePermissions(result.data.result?.length || 0);
        }
      });
    } else if (customer) {
      updatePermissions(customer.result?.length || 0);
    }
  }, [
    customer,
    isOnboardingDrawerOpen,
    customerCount,
    refetchCustomer,
    setCustomerCount,
  ]);

  useEffect(() => {
    //set user count
    if (usersData) {
      setUserCount(usersData.result?.length || 0);
    }
    //set user count less than  set user on boarding to true
    if (userCount <= 0) {
      setUserOnBoarding(false);
    } else {
      setUserOnBoarding(true);
    }
  }, [userCount, usersData, isOnboardingDrawerOpen]);

  const seCloseFunction = () => {
    setIsUserOnBoardingDrawerOpen(false);
    setIsOnboardingDrawerOpen(false);
    setTimeout(() => {
      refetchUsers().then((result) => {
        if (result.data) {
          setUserCount(result.data.result?.length || 0);
        }
      });
    }, 1500);
  };

  if (
    !isPermitted &&
    !isCustomerLoading &&
    (sampleDataStatus == "skipped" || sampleDataStatus == "removed")
  ) {
    // if (!isPermitted && !isCustomerLoading) {
    return (
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          p: "12px",
          backgroundColor: theme.palette.neutral["005"],
          // height: "100%", // fixed typo in 'height'
          height: "calc(100vh - 64px)",
        }}
      >
        <Box
          sx={{
            padding: "32px",
            backgroundColor: "#ffff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            borderRadius: "16px",
          }}
        >
          <CustomerOnBoardingComponent
            setIsOnboardingDrawerOpen={setIsOnboardingDrawerOpen}
            onBoarding={"customer"}
          />
          {isOnboardingDrawerOpen && (
            <CustomerOnBoardingDrawer
              open={isOnboardingDrawerOpen}
              onClose={seCloseFunction}
              callingFrom={"onboarding"}
              onBoarding="customer"
            />
          )}
        </Box>
      </Box>
    );
  }

  // else if (!userOnBoarding && !isCustomerLoading && !isUsersLoading) {
  //   return (
  //     <Box
  //       sx={{
  //         // flexGrow: 1,
  //         overflowY: "auto",
  //         p: "12px",
  //         backgroundColor: theme.palette.neutral["005"],
  //         // height: "100%", // fixed typo in 'height'
  //         height: "calc(100vh - 64px)",
  //         flex: 1,
  //       }}
  //     >
  //       <Box
  //         sx={{
  //           padding: "32px",
  //           backgroundColor: "#ffff",
  //           display: "flex",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           width: "100%",
  //           height: "100%",
  //           borderRadius: "16px",
  //         }}
  //       >
  //         <CustomerOnBoardingComponent // used for both customer and user onboarding
  //           setIsOnboardingDrawerOpen={setIsUserOnBoardingDrawerOpen}
  //           onBoarding={"user"}
  //         />
  //         {isUserOnBoardingDrawerOpen && (
  //           <CustomerOnBoardingDrawer
  //             open={isUserOnBoardingDrawerOpen}
  //             onClose={seCloseFunction}
  //             callingFrom={"onboarding"}
  //             onBoarding={"user"}
  //             setUserCount={setUserCount}
  //           />
  //         )}
  //       </Box>
  //     </Box>
  //   );
  // }

  return <>{children}</>;
};
